import type { DecisionMaker as DM } from './index';

const primaryRoles = ['governor', 'mayor', 'executive', 'commissioner', 'chair', 'judge', 'supervisor', 'president'];

export function getPrimaryDms(allDms: DM[]): DM[] | [] {
	const primaries = allDms.filter((dm) => {
		if (!dm.title) return false;
		const title = dm.title.toLowerCase();
		return primaryRoles.some((role) => title.includes(role));
	});
	return primaries;
}
